import { useContext, useState, useEffect } from "react";

import {
  StyleSheet,
  View,
  Text,
  ScrollView,
} from "react-native";
import SafeAreaView from "../components/SafeAreaView";

//import Ionicons from "react-native-vector-icons/Ionicons";
import { Ionicons } from "../components/VectorIcons";

import CustomButton from "../components/CustomButton";
import InputField from "../components/InputField";
import { AuthContext } from "../context/AuthContext";
import PageHeader from "../components/PageHeader";
import * as Config  from "../config";
import axios from "axios";
import qs from "qs";
import { EventRegister } from "react-native-event-listeners";
import { getSchemeStyle } from "../context/helper";
import ActivityScreen from "./activityscreen";

const ChangeBranchScreen = ({ navigation, route }) => {
  const schemeStyles = getSchemeStyle();

  const [dataLoaded, setDataLoaded] = useState(false);
  const { branchid } = route.params;
  const { userToken, useFirm } = useContext(AuthContext);

  const [branchName, setBranchName] = useState("");
  const [branchAdress, setBranchAdress] = useState("");
  const [branchEMails, setBranchEMails] = useState("");

  const [resultText, setResultText] = useState("");

  const loadData = async () => {
    setDataLoaded(false);

    const url = `${Config.BASE_URL}/getdata`;
    let data = {
      action: "branchchange",
      firmid: useFirm.current,
      branchid: branchid,
    };
    let options = {
      method: "POST",
      headers: {
        "content-type": "application/x-www-form-urlencoded",
        Authorization: "Bearer " + userToken,
      },
      data: qs.stringify(data),
      url,
    };
    await axios(options)
      .then((res) => {
        let _branchdata = res.data;
        //console.log(_branchdata);
        if (_branchdata && _branchdata.result == "OK") {
          setBranchName(_branchdata.data.name);
          setBranchAdress(_branchdata.data.adress);
          setBranchEMails(_branchdata.data.emails);
        }
      })
      .catch((e) => {
        console.log(`BranchChange error ${e}`);
      });
    setDataLoaded(true);
  };

  const saveBranchData = async (bID, bName, bAdress, bEMail) => {
    return new Promise(async (resolve, reject) => {
      const url = `${Config.BASE_URL}/getdata`;
      let data = {
        action: "branchsave",
        firmid: useFirm.current,
        branchid: bID,
        branchName: bName,
        branchAdress: bAdress,
        branchEMail: bEMail
      };
      let options = {
        method: "POST",
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + userToken,
        },
        data: qs.stringify(data),
        url,
      };
      await axios(options)
        .then((res) => {
          //console.log(res);
          let _data = res.data;
          if (_data && _data.result == "OK") {
            resolve({ result: "OK", reason: "" });
          } else if (_data && _data.result == "Failed")
          reject({ result: "Failed", code: 200, reason: "" });
        })
        .catch((e) => {
          //console.log(e);
          reject({
            result: "Failed",
            code: e.response.status,
            reason: e.response.data,
          });
        });
    });
  };

  const fieldCheck = (brName, brAdress) => {
    return brName.length > 0 && brAdress.length > 0;
  };

  useEffect(() => {
    loadData();
  }, []);

  if (!dataLoaded) {
    return (
      <ActivityScreen />
    );
  }

  return (
    <SafeAreaView style={[styles.mainArea,schemeStyles.Background]}>
      <PageHeader navigation={navigation} />
      <ScrollView style={styles.mainContainer}>
        <View>
          <Text style={[styles.titleText,schemeStyles.grayText]}>Standortdaten ändern</Text>
        </View>
        <InputField
          style={[styles.inputField,schemeStyles.BorderC,schemeStyles.defaultText,schemeStyles.placeholderText]}
          label={"Standortname"}
          icon={
            <Ionicons name="pricetag-outline" size={24} color={schemeStyles.grayIcon.color} />
          }
          value={branchName}
          onChangeText={(text) => setBranchName(text)}
        />
        <InputField
          multiline={true}
          style={[styles.inputField,schemeStyles.BorderC,schemeStyles.defaultText,schemeStyles.placeholderText]}
          label={"Adresse"}
          icon={
            <Ionicons name="location-outline" size={24} color={schemeStyles.grayIcon.color} />
          }
          value={branchAdress}
          onChangeText={(text) => setBranchAdress(text)}
        />
        <InputField
          multiline={true}
          inputMode={"email"}
          autoCapitalize={"none"}
          style={[styles.inputField,schemeStyles.BorderC,schemeStyles.defaultText,schemeStyles.placeholderText]}
          label={"E-Mail-Adressen"}
          icon={
            <Ionicons name="at-outline" size={24} color={schemeStyles.grayIcon.color} />
          }
          value={branchEMails}
          onChangeText={(text) => setBranchEMails(text)}
          keyboardType={"email-address"}
          />
        <View style={styles.resultContainer}>
          <Text style={schemeStyles.resultText}>{resultText}</Text>
        </View>
        <View style={styles.buttonContainer}>
          <CustomButton
            style={[styles.buttons,schemeStyles.buttonText]}
            disabled={!fieldCheck(branchName, branchAdress)}
            onPress={() => {
              saveBranchData(branchid,branchName,branchAdress,branchEMails)
                .then((res) => {
                  //console.log(res);
                  EventRegister.emit(Config.Events.BRANCH_CHANGE,{branchid: branchid, branchname: branchName});
                  navigation.goBack();
                })
                .catch((res) => {
                  setResultText(res.reason);
                });
            }}
          >
            OK
          </CustomButton>
          <View style={styles.spacer} />
          <CustomButton
            style={[styles.buttons,styles.backButton,schemeStyles.buttonText]}
            onPress={() => {
              navigation.goBack();
            }}
          >
            Zurück
          </CustomButton>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default ChangeBranchScreen;

const styles = StyleSheet.create({
  mainArea: {
    flex: 1,
    paddingTop: 20,
  },
  mainContainer: {
    paddingHorizontal: 25,
  },
  imageContainer: {
    alignItems: "flex-end",
    flex: 1,
    marginBottom: 40,
    marginRight: 25,
  },
  spaceView: {
    flex: 1,
  },
  mainImage: {
    opacity: 0.8,
    width: 150,
    height: 150,
  },
  titleText: {
    fontFamily: "Roboto-Medium",
    fontSize: 28,
    fontWeight: "500",
    color: "#333",
    marginBottom: 30,
  },
  inputField: {
    fontFamily: "Roboto-Regular",
    fontSize: 20,
    marginBottom: 20,
    height: 60
  },
  buttonContainer: {
    flexDirection: "row",
  },
  buttons: {
    flex: 1,
  },
  backButton: {
    backgroundColor: "#555"
  },
  spacer: {
    width: 10,
  },
  resultContainer: {
    marginBottom: 10,
  },
});
